import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { OverviewCategory } from 'shared/src/api';

export const useLogClickExpandableCategoryList = () => {
  return useCallback((category: OverviewCategory) => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_EXPANDABLE_CATEGORY_LIST',
      analytics: {
        SCREEN: 'OVERVIEW',
        ...category.logging.analytics,
      },
    });
  }, []);
};
